// 活动管理api
import { ServerDistApi} from '@/group-cloud/network/ServerBizApi';


export class invoiceApi {
    //发票申请列表 查询
    public static queryInvoiceList(data) {
        return ServerDistApi.send('/invoice/info/web/list', data);
    }
    //获取申请单主体
    public static getInvoiceBody(data) {
        return ServerDistApi.send('/invoice/info/web/getBody', data);
    }
    //模糊检索客户名称
    public static getClient(data) {
        return ServerDistApi.send('/invoice/info/web/getClient', data);
    }
    //获取客户类型
    public static getCustomerType(data) {
        return ServerDistApi.send('/invoice/info/web/getCustomerType', data);
    }
    //创建申请单
    public static submitApply(data) {
        return ServerDistApi.send('/invoice/info/web/submit', data);
    }

    //发票申请详情
    public static detailInvoice(data) {
        return ServerDistApi.send('/invoice/info/web/detail', data);
    }
    //操作日志
    public static operateLog(data) {
        return ServerDistApi.send('/invoice/his/list', data);
    }
    //审批
    public static approve(data) {
        return ServerDistApi.send('/invoice/info/web/operation', data);
    }
    //增加备注信息
    public static saveDesc(data) {
        return ServerDistApi.send('/invoice/info/save/note', data);
    }
}
